(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("devour-client"), require("axios"));
	else if(typeof define === 'function' && define.amd)
		define(["devour-client", "axios"], factory);
	else if(typeof exports === 'object')
		exports["pluginSlot"] = factory(require("devour-client"), require("axios"));
	else
		root["pluginSlot"] = factory(root["devour-client"], root["axios"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__4a43__, __WEBPACK_EXTERNAL_MODULE_cebe__) {
return 